import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { Settings } from 'luxon';

Settings.defaultLocale = 'de-DE';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
